export default __webpack_public_path__ + "alberta-search-clear.8d85e6aa4a4011062ca5.svg";